






















































































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../store";
import {PlayerColor, PlayersData} from "../../types";
import EventApi from "../api/EventsApi";

@Component({
    components: {},
    props: {
        playerId: {
            required: true,
            type: String
        },
        players: {
            required: true,
            type: Array
        },
        visibleFor: {
            required: true,
            type: Array
        },
        hidePlayerEye: {
            required: false,
            type: Boolean,
            default: true
        },
        overallVisibility: {
            required: false,
            type: Number,
            default: 2
        },
        isMessage: {
            type: Boolean,
            default: false
        },
        allowAnonymity: {
            type: Boolean,
            default: true
        }
    }
})

export default class ControlVisibility extends Vue {
    private isAnonymous: boolean = false;
    private playerId!: string;
    private overallVisibility!: number;
    private hidePlayerEye!: boolean;
    private visibleFor!: Array<string>;
    private players!: Array<PlayerColor>;
    private listIsVisible = false;
    private isMessage!: boolean;

    mounted(): void
    {
        this.listIsVisible = this.isMessage;
    }

    /**
     * Данные об игроках
     */
    private get playersData(): PlayersData
    {
        return store.getters.getGameState.playersData;
    }

    /**
     * Сообщение/задание видно для всех
     */
    private get isVisibleForAll(): boolean
    {
        if (this.overallVisibility === 1) {
            return true;
        }

        if (this.overallVisibility === 0) {
            return false;
        }

        if (!this.visibleFor.length) {
            return true;
        }

        return this.players.length === this.visibleFor.length;
    }

    /**
     * Сообщение/задание не видно для всех
     */
    private get isInvisibleForAll(): boolean
    {
        if (this.overallVisibility === 0) {
            return true;
        }

        if (this.overallVisibility === 1) {
            return false;
        }

        if (!this.visibleFor.length) {
            return false;
        }

        return false;
    }

    /**
     * Имя игрока
     */
    private getPlayerName(playerId: string): string
    {
        return this.playersData[playerId].name;
    }

    private toggleVisibility(playerId: string): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-visibility', playerId);
    }

    private toggleVisibilityForAll(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-visibility-all');
    }

    private isVisibleForPlayer(playerId: string): boolean
    {
        return this.visibleFor.indexOf(playerId) !== -1;
    }

    /**
     * Показывать иконку видимости для текущего игрока
     * @param player
     * @return {boolean}
     */
    private isPlayerEyeVisible(player: any): boolean
    {
        if (player.id !== this.playerId) {
            return true;
        }

        return !this.hidePlayerEye;
    }

    /**
     * Изменить анонимность
     */
    private toggleAnonymity(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('toggle-anonymity', this.isAnonymous);
    }

    /**
     * Изменить анонимность
     */
    private toggleListVisibility(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.listIsVisible = !this.listIsVisible;
        this.$emit('toggle-list-visibility');
    }

    /**
     * Изменить анонимность
     */
    private closeListVisibility(): void
    {
        this.listIsVisible = false;
    }
}

